<template>
  <div class="d-flex justify-space-between my-1" style="width: 100%">
    <div style="width: 100%">
      {{ title }}
    </div>
    <div :class="contentClass" style="width: 100%">
      {{ contentText }}
    </div>
  </div>
</template>
<script>
import { useStatusStyles } from '@/composables/useStatusStyles'
export default {
  name: 'ShootingDetailsContent',

  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      type: String
    },
    contentType: {
      type: String,
      default: 'text',
      validator: (value) => ['text', 'status', 'date'].includes(value)
    }
  },

  setup() {
    const { getCssClass, getStatusText } = useStatusStyles()
    return {
      getCssClass,
      getStatusText
    }
  },

  computed: {
    contentClass() {
      return this.getCssClass(this.content)
    },
    contentText() {
      return this.getStatusText(this.content)
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .text-content {
  flex-flow: row wrap !important;
}
</style>
